import { usePaymentMethodsJustifiContext } from '../payment-methods-justifi.context';
import { CardOnFileProviderWrapper } from './card-on-file-provider-wrapper';

export type AddCardProviderJustifiProps = React.PropsWithChildren<object>;
export const AddCardProviderJustifi = ({ children }: AddCardProviderJustifiProps) => {
  const { person, invoiceId, onError } = usePaymentMethodsJustifiContext();

  return (
    <CardOnFileProviderWrapper personId={person?.personId} invoiceId={invoiceId} onError={onError}>
      {children}
    </CardOnFileProviderWrapper>
  );
};
